const user = {
  state: {
    userInfo: {
      name: "yg"
    },
  },

  mutations: {
  },
  actions: {
  }
}

export default user
